import {flagPathByCountryCode} from '@hconnect/uikit'
import {GenericInput, LabelRegular} from '@hm/fundamental'
import {CircularProgress} from '@material-ui/core'
import React from 'react'

import {DropdownOption} from '../../../common/DropdownOption'
import {useDependencyFetcher} from '../../../common/hooks/useDependencyFetcher'
import {useTranslation} from '../../../hooks/useTranslation'
import {DynamicSelectDataScopeInput} from '../../../modules/DataScopeConfiguration'
import {GroupedRoleAssignment} from '../../../modules/ManageUsers.selectors'

import {CountryDataScope} from './CountryDataScope'

interface Props {
  dataScope: string
  groupedRoleAssignment: GroupedRoleAssignment
  configuration: DynamicSelectDataScopeInput
}

export const DynamicLabel: React.FC<Props> = ({
  dataScope,
  groupedRoleAssignment,
  configuration
}) => {
  const {fetchValues} = configuration

  const {t} = useTranslation()

  const dependencies =
    configuration.dependsOn !== undefined
      ? configuration.dependsOn
          .map((dep) => groupedRoleAssignment.commonDataScopes[dep])
          .filter((dependency) => dependency !== undefined)
      : []

  const {
    isLoading,
    error,
    data: options
  } = useDependencyFetcher<DropdownOption[]>(fetchValues, dataScope, dependencies.flat())

  if (isLoading) {
    return (
      <div key={dataScope} className="flex flex-col px-2 min-w-100px">
        <LabelRegular className="text-foreground_faded">
          {t(`roleAssignment.dataScope.${dataScope}`)}
        </LabelRegular>
        <CircularProgress size={20} />
      </div>
    )
  }

  if (error) {
    return (
      <div key={dataScope} className="flex flex-col px-2 min-w-100px">
        <LabelRegular className="text-foreground_faded">
          {t(`roleAssignment.dataScope.${dataScope}`)}
        </LabelRegular>
        <div>{groupedRoleAssignment.commonDataScopes[dataScope]}</div>
      </div>
    )
  }

  const textFieldValue = (() => {
    if (!options) {
      return groupedRoleAssignment.commonDataScopes[dataScope]
    }
    const selectedKey = groupedRoleAssignment.commonDataScopes[dataScope]
    const selectedOption = options.find((option) => option.key === selectedKey)

    if (!selectedOption) {
      return groupedRoleAssignment.commonDataScopes[dataScope]
    }

    return selectedOption.label
  })()

  const countryId =
    dataScope === 'countryId'
      ? (groupedRoleAssignment.commonDataScopes[dataScope] as string)
      : undefined

  return (
    <div className="flex">
      {dataScope === 'countryId' ? (
        <CountryDataScope countryId={countryId} />
      ) : (
        <GenericInput
          key={dataScope}
          label={t(`roleAssignment.dataScope.${dataScope}`)}
          value={textFieldValue as string}
          isReadOnly={true}
          size={textFieldValue.toString()?.length}
        />
      )}
    </div>
  )
}
